import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/intezmenyek",
    name: "intezmenyek",
    component: () => import("../views/IntezmenyekView.vue"),
  },
  {
    path: "/felhasznalok",
    name: "felhasznalok",
    component: () => import("../views/FelhasznalokView.vue"),
  },
  {
    path: "/backup",
    name: "backup",
    component: () => import("../views/BackupView.vue"),
  },
  {
    path: "/restore",
    name: "restore",
    component: () => import("../views/RestoreView.vue"),
  },
  {
    path: "/kotvallrogzit",
    //path: "/kotvall/:id",
    name: "kotvallrogzit",
    component: () => import("../views/KotVallViewRogzit.vue"),
    //params: true
  },
  {
    path: "/kotvallindit",
    name: "kotvallindit",
    component: () => import("../views/KotVallViewIndit.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
